import axios from 'lib/apiClient';

export const uploadMedia = (file, account_id, filename, onUploadProgress) => {
  const formData = new FormData();
  formData.append('media_file', file, filename);
  if (account_id) {
    formData.append('account_id', account_id);
  }
  return axios.post(`API/1_0/postMedia.php`, formData, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
    onUploadProgress: (progressEvent) => {
      const { loaded, total } = progressEvent;
      const percent = Math.floor((loaded * 100) / total);
      if (onUploadProgress) {
        onUploadProgress(percent);
      }
    },
  });
};

export const getMediaUrl = (hash) => {
  return axios
    .get('API/1_0/getMediaURL.php', { params: { media_hash: hash } })
    .then((r) => r.media_url);
};
